export const BFX_FIND_TRADE_CLIENT_VALUE = "client";
export const BFX_FIND_TRADE_RISK_VALUE = "risk";
